import { ControlAttributeType, } from "@cloudpivot/form/typings";
import { formatterRequiredFormula, } from "@cloudpivot/form/utils";
import baseAttribute from "@cloudpivot/form/src/common/component-base-attribute";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [
                'documentRoot',
                'fileRootNode',
                "requiredFormula",
                "fileType",
                "libraryCode",
                "countLimit",
                "displayDownload"
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: "数据选择" }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: "数据选择" }),
        // 是否必填
        requiredFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "requiredRule",
            inputComponent: () => import("@cloudpivot/form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterRequiredFormula,
            },
        },
        // 文档根节点
        fileRootNode: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "dataSelectFileCondition",
            inputComponent: () => import("@cloudpivot/form/src/common/components/data-select-file-condition.vue"),
            options: {
                hideField: ["documentRoot"],
                importModal: (attr, attrs) => {
                    const opts = {};
                    attrs.forEach((attrItem) => {
                        opts[attrItem.field] = attrItem.value;
                    });
                    return opts;
                },
                callback: (key, attr, attrs, vm) => {
                    let val = attrs.find((a) => a.field === "documentRoot").value;
                    vm.updateAttribute(key, "documentRoot", val);
                },
                exportModal: (data, attr, attrs, callback, vm) => {
                    let val = data.value;
                    vm.$emit("change", "documentRoot", data);
                    return data.type;
                },
                formatter: (valueType, attrs, getControls) => {
                    let orgRootObj = attrs.find((a) => a.field === "documentRoot");
                    let text = orgRootObj.value.name || '';
                    return text;
                },
            },
        },
        fileType: {
            inputMethod: ControlAttributeType.Dropdown,
            value: 'file',
            options: {
                list: [
                    {
                        value: 'file',
                        label: "文件",
                    },
                    {
                        value: 'folder',
                        label: "文件夹",
                    }
                ],
                callback: (key, attr, attrs, vm) => {
                    let val = attrs.find((a) => a.field === "fileType").value;
                    vm.updateAttribute(key, "fileType", val);
                }
            }
        },
        libraryCode: {
            inputMethod: ControlAttributeType.Dropdown,
            value: 'yuanshi',
            options: {
                list: [
                    {
                        value: 'yuanshi',
                        label: "原始资料库",
                    },
                    {
                        value: 'gongzuo',
                        label: "工作资料库",
                    },
                    // {
                    //   value: 'daichuli',
                    //   label: "待处理资料库",
                    // },
                    // {
                    //   value: 'fangxing',
                    //   label: "放行资料库",
                    // },
                    {
                        value: 'shenbao',
                        label: "申报资料库",
                    }
                ],
                callback: (key, attr, attrs, vm) => {
                    let val = attrs.find((a) => a.field === "libraryCode").value;
                    vm.updateAttribute(key, "libraryCode", val);
                }
            }
        },
        countLimit: {
            value: ""
        },
        displayDownload: {
            inputMethod: ControlAttributeType.Dropdown,
            value: true,
            options: {
                list: [
                    {
                        value: '1',
                        label: "true",
                    },
                    {
                        value: '2',
                        label: "false",
                    }
                ],
                callback: (key, attr, attrs, vm) => {
                    let val = attrs.find((a) => a.field === "displayDownload").value;
                    vm.updateAttribute(key, "displayDownload", val);
                }
            }
        }
    },
};
